import { TabletShell, Timeline, EXISTING } from "./tablet";
import { Button } from "./primitives";
import { PLAN, TONE } from "./data";

const PROPOSED = [
  { p: "Maya", h: 6, m: 15, mins: 60, label: "Hydrating Facial", sub: "6:15 · Sophie R.", bg: TONE.mint.bg, fg: TONE.mint.fg, dashed: true },
  { p: "Lena", h: 7, m: 20, mins: 20, label: "Brow Shaping", sub: "7:20 · Sophie R.", bg: TONE.lilac.bg, fg: TONE.lilac.fg, dashed: true },
];

export default function S5() {
  return (
    <TabletShell id="s5" active="Requests">
      <div style={{ fontSize: 26, color: "var(--ink-40)" }}>Requests / {PLAN.customer}</div>
      <div className="serif" style={{ fontSize: 76, fontWeight: 500, lineHeight: 1, marginTop: 12 }}>Suggest a plan</div>
      <div style={{ marginTop: 18, fontSize: 28, color: "var(--ink-60)" }}>marova found the earliest gap that fits both services in one visit.</div>

      <div style={{ marginTop: 50, background: "#fff", borderRadius: 36, border: "1px solid var(--ink-06)", padding: "40px 48px" }}>
        {PLAN.services.map((s, i) => (
          <div key={s.name} style={{ display: "flex", alignItems: "center", gap: 28, padding: "26px 0", borderBottom: i === 0 ? "1px solid var(--ink-06)" : "none" }}>
            <div style={{ width: 150, fontSize: 40, fontWeight: 600 }}>{s.time}</div>
            <span style={{ width: 16, height: 16, borderRadius: "50%", background: TONE[s.tone].fg }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 34, fontWeight: 500 }}>{s.name}</div>
              <div style={{ fontSize: 26, color: "var(--ink-60)" }}>{s.provider} · {s.mins} min</div>
            </div>
            <div style={{ fontSize: 34, fontWeight: 500 }}>${s.price}</div>
          </div>
        ))}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 30, paddingTop: 30, borderTop: "2px solid var(--charcoal)" }}>
          <div style={{ fontSize: 26, color: "var(--ink-60)" }}>5-min hand-off between rooms · done by 7:40 PM</div>
          <div style={{ fontSize: 48, fontWeight: 600 }}>${PLAN.total}</div>
        </div>
      </div>

      <Timeline slots={[...EXISTING, ...PROPOSED]} height={560} />

      <div style={{ position: "absolute", left: 72, right: 72, bottom: 60, display: "flex", gap: 20 }}>
        <Button size={30} style={{ flex: 1 }}>Send plan to Sophie</Button>
        <Button size={30} tone="ghost" style={{ width: 300 }}>Adjust</Button>
      </div>
    </TabletShell>
  );
}
